var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTabArrowHead = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 -1 0 46)",
    fill: "#E5E5E5",
    d: "M0 0h101v46H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.828 25.828a4 4 0 010-5.656L20.92 1.08c5.858-5.858 15.356-5.858 21.213 0l19.092 19.092a4 4 0 010 5.656L42.133 44.92c-5.857 5.858-15.355 5.858-21.213 0L1.828 25.828z",
    fill: "#00845b"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTabArrowHead);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tab-arrow-head.f29935f10230f10c45d9dce9f8889cbb.svg";